import type { NDateLocale } from './enUS'
import { sl } from 'date-fns/locale'

const dateSlSI: NDateLocale = {
  name: 'sl-SI',
  locale: sl
}

export default dateSlSI
